import { Link } from "react-router-dom";
import { MapPin, Compass, ArrowUpRight } from "lucide-react";
import { MELBOURNE_METRO, REGIONAL_VIC, CONTACT } from "../data/site";

export default function Areas() {
  return (
    <div data-testid="areas-page">
      {/* Header */}
      <section className="py-24 md:py-32 bg-zinc-950 text-white border-b-2 border-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="overline text-zinc-500"><span className="text-[#E62117] mr-2">◆</span>Where we work</p>
          <h1 data-testid="areas-title" className="font-display text-6xl md:text-8xl lg:text-9xl uppercase leading-[0.88] mt-6">
            Areas we<br />
            <span className="text-[#E62117]">service.</span>
          </h1>
          <p className="mt-8 text-lg md:text-xl text-zinc-400 max-w-2xl">
            Based in Melbourne's west. Working across every metro suburb and reaching well into regional Victoria.
          </p>
        </div>
      </section>

      {/* Grid */}
      <section className="py-24 md:py-32 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Metro */}
          <div data-testid="areas-metro-block" className="border-2 border-black">
            <div className="bg-black text-white p-6 border-b-2 border-black flex items-center justify-between">
              <div>
                <p className="overline text-zinc-400">Zone 01</p>
                <h2 className="font-display text-3xl md:text-4xl uppercase mt-1 flex items-center gap-3">
                  <MapPin className="text-[#E62117]" size={28} />
                  Melbourne Metro
                </h2>
              </div>
              <span className="font-mono-brand text-xl md:text-2xl">{MELBOURNE_METRO.length}+</span>
            </div>
            <div className="p-6 md:p-8 grid grid-cols-2 sm:grid-cols-3 gap-3">
              {MELBOURNE_METRO.map((s) => (
                <div
                  key={s}
                  data-testid={`area-metro-${s.toLowerCase().replace(/\s+/g, '-')}`}
                  className="border-2 border-black px-3 py-2 text-sm font-bold uppercase tracking-wider hover:bg-[#E62117] hover:text-white hover:border-[#E62117] transition-colors"
                >
                  {s}
                </div>
              ))}
            </div>
            <div className="p-6 md:p-8 border-t-2 border-black bg-zinc-50">
              <p className="text-sm text-zinc-700">
                All Melbourne metro suburbs covered — CBD, inner-city, north, south, east and the west (our home turf).
              </p>
            </div>
          </div>

          {/* Regional */}
          <div data-testid="areas-regional-block" className="border-2 border-black">
            <div className="bg-[#E62117] text-white p-6 border-b-2 border-black flex items-center justify-between">
              <div>
                <p className="overline text-white/70">Zone 02</p>
                <h2 className="font-display text-3xl md:text-4xl uppercase mt-1 flex items-center gap-3">
                  <Compass size={28} />
                  Regional Victoria
                </h2>
              </div>
              <span className="font-mono-brand text-xl md:text-2xl">{REGIONAL_VIC.length}+</span>
            </div>
            <div className="p-6 md:p-8 grid grid-cols-2 sm:grid-cols-3 gap-3">
              {REGIONAL_VIC.map((s) => (
                <div
                  key={s}
                  data-testid={`area-regional-${s.toLowerCase().replace(/\s+/g, '-')}`}
                  className="border-2 border-black px-3 py-2 text-sm font-bold uppercase tracking-wider hover:bg-black hover:text-white transition-colors"
                >
                  {s}
                </div>
              ))}
            </div>
            <div className="p-6 md:p-8 border-t-2 border-black bg-zinc-50">
              <p className="text-sm text-zinc-700">
                We travel — Geelong, Ballarat, Bendigo and beyond. Rural properties and holiday homes welcome.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Not listed */}
      <section className="py-20 bg-zinc-50 border-t-2 border-black">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <p className="overline">Can't see your suburb?</p>
          <h3 className="font-display text-4xl md:text-5xl uppercase mt-4">Ask us — we probably still cover you.</h3>
          <p className="mt-4 text-zinc-700">
            The list above is a snapshot. Give us your postcode and we'll confirm on the phone.
          </p>
          <div className="mt-8 flex justify-center gap-4 flex-wrap">
            <a href={`tel:${CONTACT.phoneRaw}`} data-testid="areas-cta-call" className="btn-primary">
              Call {CONTACT.phone}
            </a>
            <Link to="/contact" data-testid="areas-cta-contact" className="btn-secondary">
              Contact Us <ArrowUpRight className="ml-2" size={16} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
